<div class="progress-outer">
    <div class="progress-inner"></div>
</div>

<style>
    .progress-outer {
        position: relative;
        background-color: white;
        height: 2px;
    }

    .progress-inner {
        height: 2px;
        background-color: black;
        width: 10%;

        animation-name: progress-animation;
        animation-duration: 1s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }

    @keyframes progress-animation {
        0% {
            transform: translateX(-10%);
        }
        100% {
            transform: translateX(990%);
        }
    }
</style>
